import React, { PropsWithChildren } from "react"

import { TopBannerContextProvider } from "./TopBanner"

export const ContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
	return <TopBannerContextProvider>{children}</TopBannerContextProvider>
}
